<style scoped>
</style>

<template>
  <div>
    <Card shadow>
      <Input style="width:200px" placeholder="字典名称" v-model="dict.name"></Input>
      <Input style="width:200px;margin-left:5px" placeholder="字典编码" v-model="dict.code"></Input>
      <Input style="width:400px;margin-left:5px" placeholder="字典描述" v-model="dict.description"></Input>
      <Button @click="addNewDict" style="margin-left:10px" icon="md-add" type="primary">添加字典</Button>
      <Button @click="deleteSelection" style="margin-left:10px" type="primary">删除选中</Button>
      <Table
        @on-selection-change="selectChange"
        stripe
        :columns="tdata.col_data"
        :data="tdata.current_data"
        :loading="tdata.loading"
        style="margin-top:10px"
        @on-row-click="rowSelect"
      ></Table>
    </Card>
    <Modal
      v-model="codeItemModal.modal"
      :title="codeItemModal.title"
      width="800"
      @on-visible-change="codeItemModalVisible"
    >
      <Input style="width:100px" placeholder="字典项文本" v-model="codeItemModal.dictItem.itemtext"></Input>
      <Input
        style="width:100px;margin-left:5px"
        placeholder="字典项值"
        v-model="codeItemModal.dictItem.itemvalue"
      ></Input>
      <Input
        style="width:100px;margin-left:5px"
        placeholder="排序号"
        v-model="codeItemModal.dictItem.ordernumber"
      ></Input>
      <Input
        style="width:150px;margin-left:5px"
        placeholder="描述"
        v-model="codeItemModal.dictItem.description"
      ></Input>
      <Button style=";margin-left:5px" icon="md-add" @click="addNewDictItem">新增字典项</Button>
      <Button style=";margin-left:5px" @click="deleteSelectDictItems">删除选中</Button>
      <Table
        @on-selection-change="onDictItemSelectChange"
        stripe
        :columns="codeItemModal.tdata.col_data"
        :data="codeItemModal.tdata.current_data"
        :loading="codeItemModal.tdata.loading"
        style="margin-top:10px"
      ></Table>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      codeItemModal: {
        selection: [],
        modal: false,
        title: "",
        dict: {},
        dictItem: {
          itemtext: "",
          itemvalue: "",
          description: "",
          ordernumber: "",
        },
        tdata: {
          //是否显示loading框
          loading: true,
          //当前表格数据
          current_data: [],
          //表头数据
          col_data: [
            {
              type: "selection",
              width: 60,
              align: "center",
            },
            {
              title: "字典项文本",
              key: "itemtext",
            },
            {
              title: "字典项值",
              key: "itemvalue",
            },
            {
              title: "排序号",
              key: "ordernumber",
            },
            {
              title: "描述",
              key: "description",
            },
          ],
        },
      },
      dict: {
        name: "",
        code: "",
        description: "",
      },
      tdata: {
        //是否显示loading框
        loading: true,
        //当前表格数据
        current_data: [],
        //表头数据
        col_data: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "字典名称",
            key: "dictname",
          },
          {
            title: "字典编码",
            key: "dictcode",
          },
          {
            title: "描述",
            key: "description",
          },
        ],
      },
      selection: [],
    };
  },
  methods: {
    onDictItemSelectChange(selection) {
      this.codeItemModal.selection = selection;
    },
    //删除选中的字典项
    deleteSelectDictItems() {
      let ids = [];
      for (let i = 0; i < this.codeItemModal.selection.length; i++) {
        ids.push(this.codeItemModal.selection[i].id);
      }
      if (ids.length == 0) {
        this.$Message.warning("请选中至少一项");
        return;
      }

      let _this = this;
      this.$http.post({
        method: "base/dictitem/deleteBatch",
        params: ids,
        success: function (data) {
          _this.codeItemModal.selection = [];
          _this.getDictItemList();
        },
        failure(code, msg) {
          _this.$Message.warning({
            title: "提示",
            content: msg,
          });
        },
      });
    },
    //新增字典项，事件
    addNewDictItem() {
      let _this = this;
      this.$http.post({
        method: "base/dictitem/add",
        params: {
          dictid: this.codeItemModal.dict.id,
          itemtext: this.codeItemModal.dictItem.itemtext,
          description: this.codeItemModal.dictItem.description,
          itemvalue: this.codeItemModal.dictItem.itemvalue,
          ordernumber: this.codeItemModal.dictItem.ordernumber,
        },
        success: function (data) {
          _this.codeItemModal.dictItem = {};
          _this.getDictItemList();
        },
        failure(code, msg) {
          _this.$Message.warning({
            title: "提示",
            content: msg,
          });
        },
      });
    },
    //字典项Modal显隐回调事件
    codeItemModalVisible(visible) {
      if (!visible) {
        this.codeItemModal.dict = {};
        this.codeItemModal.dictItem = {};
      }
      this.codeItemModal.selection = [];
    },
    //点击字典行，事件
    rowSelect(row) {
      this.codeItemModal.modal = true;
      this.codeItemModal.title = row.dictname;
      this.codeItemModal.dict = row;
      this.getDictItemList();
    },
    //根据dictid，获取代码项列表
    getDictItemList() {
      let _this = this;
      this.$http.get({
        method: "base/dictitem/list",
        params: {
          dictid: this.codeItemModal.dict.id,
        },
        success: function (data) {
          _this.codeItemModal.tdata.current_data = data;
          _this.codeItemModal.tdata.loading = false;
        },
        failure(code, msg) {
          _this.tdata.loading = false;
          _this.$Message.warning({
            title: "提示",
            content: msg,
          });
        },
      });
    },
    //字典选中状态变更回调事件
    selectChange(selection) {
      this.selection = selection;
    },
    //删除选中的字典行
    deleteSelection() {
      let ids = [];
      for (let i = 0; i < this.selection.length; i++) {
        ids.push(this.selection[i].id);
      }
      if (ids.length == 0) {
        this.$Message.warning("请选中至少一项");
        return;
      }
      let _this = this;

      this.$Modal.confirm({
        title: "提示",
        content: "确定要删除吗？",
        onOk: () => {
          _this.$http.post({
            method: "base/dict/deleteBatch",
            params: ids,
            success: function (data) {
              _this.getDictList();
            },
            failure(code, msg) {
              _this.$Message.warning({
                title: "提示",
                content: msg,
              });
            },
          });
        },
      });
    },
    //添加字典事件
    addNewDict() {
      let _this = this;
      this.$http.post({
        method: "base/dict/add",
        params: {
          dictname: this.dict.name,
          dictcode: this.dict.code,
          description: this.dict.description,
        },
        success: function (data) {
          _this.dict = {};
          _this.getDictList();
        },
        failure(code, msg) {
          _this.$Message.warning({
            title: "提示",
            content: msg,
          });
        },
      });
    },
    //加载字典列表
    getDictList() {
      let _this = this;
      this.$http.get({
        method: "base/dict/list",
        success: function (data) {
          _this.tdata.loading = false;
          _this.tdata.current_data = data;
        },
        failure(code, msg) {
          _this.tdata.loading = false;
          _this.$Message.warning({
            title: "提示",
            content: msg,
          });
        },
      });
    },
  },
  mounted() {
    this.getDictList();
  },
};
</script>